"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'QrcodeGenerator',
  props: {
    url: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 36
    }
  },
  data: function data() {
    return {
      previewVisible: false,
      qrcode: null,
      previewQrcode: null
    };
  },
  mounted: function mounted() {
    this.generateQrcode();
  },
  watch: {
    url: {
      handler: function handler() {
        this.generateQrcode();
      },
      immediate: true
    }
  },
  methods: {
    generateQrcode: function generateQrcode() {
      var _this = this;
      if (!this.url) return;
      this.$nextTick(function () {
        // 清除旧的二维码
        if (_this.qrcode) {
          _this.$refs.qrcode.innerHTML = '';
        }

        // 生成新的二维码
        _this.qrcode = new _qrcodejs.default(_this.$refs.qrcode, {
          text: _this.url,
          width: _this.size,
          height: _this.size,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: _qrcodejs.default.CorrectLevel.H
        });
      });
    },
    showPreview: function showPreview() {
      var _this2 = this;
      this.previewVisible = true;
      this.$nextTick(function () {
        // 生成预览用的大尺寸二维码
        if (_this2.$refs.previewQrcode) {
          _this2.$refs.previewQrcode.innerHTML = '';
          _this2.previewQrcode = new _qrcodejs.default(_this2.$refs.previewQrcode, {
            text: _this2.url,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: _qrcodejs.default.CorrectLevel.H
          });
        }
      });
    },
    openUrl: function openUrl() {
      if (this.url) {
        window.open(this.url, '_blank');
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.qrcode) {
      this.qrcode = null;
    }
    if (this.previewQrcode) {
      this.previewQrcode = null;
    }
  }
};